import { Link, useLocation } from 'react-router-dom';
export default function RequestDataLink({children,...props}) {
 const location=useLocation();
 return <Link {...props} to="/request-data" state={{backgroundLocation:location}}>{children}</Link>;
}
